import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, doc, getDoc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; 
import { useNavigate } from 'react-router-dom'; 
import { fullMenu } from '../dashboard/layout'; // Замаа шалгаарай
import { FiUsers, FiSave, FiCheckSquare, FiSquare, FiChevronDown } from 'react-icons/fi';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);
const Toast = MySwal.mixin({ toast: true, position: 'top-end', showConfirmButton: false, timer: 2500, timerProgressBar: true, iconColor: '#10b981', customClass: { popup: 'tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-border-slate-100 tw-px-4 tw-py-3', title: 'tw-text-sm tw-font-bold tw-text-slate-800 tw-m-0' } });

const PermissionCompany = () => {
    const db = getFirestore();
    const auth = getAuth(); 
    const navigate = useNavigate(); 
    
    const [authChecking, setAuthChecking] = useState(true);
    const [myParkingId, setMyParkingId] = useState(''); // Мастерийн өөрийнх нь зогсоол
    
    const [usersList, setUsersList] = useState([]);
    const [selectedUserEmail, setSelectedUserEmail] = useState('');
    const [userPermissions, setUserPermissions] = useState([]);
    const [fetchingUsers, setFetchingUsers] = useState(false);
    const [savingPermissions, setSavingPermissions] = useState(false);

    // 1. MASTER ЭРХ ШАЛГАХ
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (!user) return navigate('/'); 
            try {
                // Энд хэрэглэгч аль зогсоолд харьяалагддагийг мэдэх хэрэгтэй.
                // Одоогоор "parking_01"-оор шалгаж байна, бодит байдал дээр user-ийн document дотор parkingId байвал сайн
                const parkingId = "parking_04"; 
                const userRef = doc(db, "parkings", parkingId, "users", user.email);
                const userSnap = await getDoc(userRef);
                
                if (userSnap.exists() && (userSnap.data().isMaster === true || userSnap.data().role === 'superadmin')) {
                    setMyParkingId(parkingId);
                    setAuthChecking(false);
                } else {
                    MySwal.fire({ icon: 'error', title: 'Хандах эрхгүй', text: 'Зөвхөн Байгууллагын Master нэвтэрнэ.'});
                    navigate('/dashboard');
                }
            } catch (error) { navigate('/dashboard'); }
        });
        return () => unsubscribe();
    }, [auth, db, navigate]);

    // 2. Ажилчдыг татах (Зөвхөн тухайн зогсоолын)
    useEffect(() => {
        if (!myParkingId) return;
        const fetchUsers = async () => {
            setFetchingUsers(true);
            const snapshot = await getDocs(collection(db, "parkings", myParkingId, "users"));
            setUsersList(snapshot.docs.map(doc => ({ email: doc.id, ...doc.data() })));
            setFetchingUsers(false);
        };
        fetchUsers();
    }, [myParkingId, db]);

    const handleUserSelect = (e) => {
        const email = e.target.value;
        setSelectedUserEmail(email);
        const selectedUser = usersList.find(u => u.email === email);
        setUserPermissions(selectedUser?.permissions || []); 
    };

    const handleTogglePermission = (url) => {
        setUserPermissions(prev => prev.includes(url) ? prev.filter(p => p !== url) : [...prev, url]);
    };

    const handleSavePermissions = async () => {
        if (!myParkingId || !selectedUserEmail) return;
        setSavingPermissions(true);
        try {
            const userRef = doc(db, "parkings", myParkingId, "users", selectedUserEmail);
            await updateDoc(userRef, { permissions: userPermissions });
            
            Toast.fire({ icon: 'success', title: 'Эрх амжилттай шинэчлэгдлээ!' });
            setUsersList(prev => prev.map(u => u.email === selectedUserEmail ? { ...u, permissions: userPermissions } : u));
        } catch (error) { Toast.fire({ icon: 'error', title: 'Хадгалах үед алдаа гарлаа' }); } 
        finally { setSavingPermissions(false); }
    };

    if (authChecking) return <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center">Уншиж байна...</div>;

    const currentUserObj = usersList.find(u => u.email === selectedUserEmail);

    return (
        <div className="tw-bg-slate-50 tw-min-h-full tw-p-4 sm:tw-p-6 lg:tw-p-8 tw-font-sans tw-text-slate-800">
            <div className="tw-max-w-5xl tw-mx-auto">
                <div className="tw-mb-8">
                    <div className="tw-flex tw-items-center tw-gap-3 tw-mb-2">
                        <div className="tw-w-10 tw-h-10 tw-rounded-xl tw-bg-emerald-600 tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-lg">
                            <FiUsers size={20} />
                        </div>
                        <h2 className="tw-text-2xl tw-font-black tw-text-slate-900 tw-tracking-tight">Ажилчдын хандах эрх</h2>
                    </div>
                    <p className="tw-text-sm tw-text-slate-500">Байгууллагынхаа ажилтнуудад аль цэс рүү хандах эрхийг олгоно.</p>
                </div>

                <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-200 tw-overflow-hidden tw-animate-in tw-fade-in">
                    <div className="tw-p-6">
                        <div className="tw-max-w-md tw-mb-8">
                            <label className="tw-block tw-text-sm tw-font-bold tw-text-slate-700 tw-mb-2">Тохируулах ажилтнаа сонгоно уу:</label>
                            <div className="tw-relative">
                                <select 
                                    className="tw-w-full tw-px-4 tw-py-3 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-xl tw-text-sm tw-font-bold focus:tw-outline-none focus:tw-border-emerald-500 tw-appearance-none"
                                    value={selectedUserEmail} onChange={handleUserSelect} disabled={fetchingUsers}
                                >
                                    <option value="">{fetchingUsers ? 'Уншиж байна...' : '-- Хэрэглэгч сонгох --'}</option>
                                    {usersList.map((u) => <option key={u.email} value={u.email}>{u.email} {u.isMaster ? '(Master)' : ''}</option>)}
                                </select>
                                <FiChevronDown className="tw-absolute tw-right-4 tw-top-1/2 tw--translate-y-1/2 tw-text-slate-400 tw-pointer-events-none" />
                            </div>
                        </div>

                        {selectedUserEmail && currentUserObj && (
                            <div className="tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-xl tw-overflow-hidden tw-animate-in tw-fade-in tw-slide-in-from-bottom-4">
                                <div className="tw-p-5">
                                    <h4 className="tw-text-sm tw-font-bold tw-text-slate-600 tw-uppercase tw-tracking-wider tw-mb-4">Зөвшөөрөгдөх цэснүүд:</h4>
                                    
                                    {currentUserObj.isMaster && (
                                        <div className="tw-mb-6 tw-p-4 tw-bg-amber-50 tw-border tw-border-amber-200 tw-text-amber-700 tw-text-xs tw-font-bold tw-rounded-xl">
                                            Энэ хэрэглэгч нь Master эрхтэй тул бүх цэс рүү хандах эрхтэй. Эрхийг хязгаарлах боломжгүй.
                                        </div>
                                    )}

                                    <div className={`tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 ${currentUserObj.isMaster ? 'tw-opacity-50 tw-pointer-events-none' : ''}`}>
                                        {fullMenu.map((item) => (
                                            <div key={item.url} className="tw-bg-white tw-border tw-border-slate-200 tw-rounded-xl tw-p-4 tw-shadow-sm hover:tw-border-emerald-200 tw-transition-colors">
                                                {item.subItems ? (
                                                    <div>
                                                        <div className="tw-font-bold tw-text-slate-800 tw-flex tw-items-center tw-gap-2 tw-mb-3 tw-border-b tw-border-slate-100 tw-pb-2">
                                                            {React.cloneElement(item.icon, { size: 16, className: "tw-text-emerald-500" })} {item.label}
                                                        </div>
                                                        <div className="tw-space-y-2 tw-pl-2">
                                                            {item.subItems.map((sub) => {
                                                                const isChecked = userPermissions.includes(sub.url);
                                                                return (
                                                                    <label key={sub.url} className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-group">
                                                                        <div className={`tw-w-5 tw-h-5 tw-rounded tw-border tw-flex tw-items-center tw-justify-center tw-transition-colors ${isChecked ? 'tw-bg-emerald-500 tw-border-emerald-500 tw-text-white' : 'tw-bg-white tw-border-slate-300 tw-text-transparent group-hover:tw-border-emerald-400'}`}>
                                                                            <FiCheckSquare size={14} />
                                                                        </div>
                                                                        <input type="checkbox" className="tw-hidden" checked={isChecked} onChange={() => handleTogglePermission(sub.url)} />
                                                                        <span className={`tw-text-sm tw-font-medium tw-transition-colors ${isChecked ? 'tw-text-slate-900' : 'tw-text-slate-500 group-hover:tw-text-slate-700'}`}>{sub.label}</span>
                                                                    </label>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <label className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer tw-group">
                                                        <div className={`tw-w-5 tw-h-5 tw-rounded tw-border tw-flex tw-items-center tw-justify-center tw-transition-colors ${userPermissions.includes(item.url) ? 'tw-bg-emerald-500 tw-border-emerald-500 tw-text-white' : 'tw-bg-white tw-border-slate-300 tw-text-transparent group-hover:tw-border-emerald-400'}`}>
                                                            <FiCheckSquare size={14} />
                                                        </div>
                                                        <input type="checkbox" className="tw-hidden" checked={userPermissions.includes(item.url)} onChange={() => handleTogglePermission(item.url)} />
                                                        <span className={`tw-text-sm tw-font-bold tw-flex tw-items-center tw-gap-2 tw-transition-colors ${userPermissions.includes(item.url) ? 'tw-text-slate-900' : 'tw-text-slate-500 group-hover:tw-text-slate-700'}`}>
                                                            {React.cloneElement(item.icon, { size: 16, className: userPermissions.includes(item.url) ? "tw-text-emerald-500" : "tw-text-slate-400" })}
                                                            {item.label}
                                                        </span>
                                                    </label>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <div className="tw-mt-6 tw-pt-4 tw-border-t tw-border-slate-200 tw-flex tw-justify-end">
                                        <button 
                                            className="tw-flex tw-items-center tw-gap-2 tw-bg-emerald-500 hover:tw-bg-emerald-600 tw-text-white tw-px-8 tw-py-3 tw-rounded-xl tw-font-bold tw-text-sm tw-shadow-sm hover:tw-shadow-md tw-transition-all disabled:tw-opacity-70 disabled:tw-cursor-not-allowed" 
                                            onClick={handleSavePermissions} 
                                            disabled={savingPermissions || currentUserObj.isMaster}
                                        >
                                            <FiSave size={18} /> {savingPermissions ? 'Хадгалж байна...' : 'Эрхийг Хадгалах'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PermissionCompany;